module.exports = __webpack_public_path__ + "img/signIn_icon.a39c5da0.png";